// @flow

import { BaseChartRenderer } from './base-chart.renderer';
import { ChartModel } from './chart.model';
import { SCALE_NUMBER } from './constants';
import { getChartMaxValue } from './utils/chart.utils';

export class ChartRenderer extends BaseChartRenderer {
    constructor (chart: ChartModel, width: number, height: number) {
        super(chart, width, height, 2);
        const _max = this.chart.getMaxSelectionValue();
        this.chartMax = getChartMaxValue(_max * 10, SCALE_NUMBER);
        this.update({ chartMax: getChartMaxValue(_max, SCALE_NUMBER) });
        this.drawFrom = this.chart.selectStart;
        this.drawTo = this.chart.selectEnd;
    }

    update (changes: any) {
        if (changes.move !== undefined || changes.toggleColumn !== undefined) {
            this.progressAnimation = true;
            this.drawFrom = this.chart.selectStart;
            this.drawTo = this.chart.selectEnd;
            const max = this.chart.getMaxSelectionValue();
            const chartMax = getChartMaxValue(max, SCALE_NUMBER);
            changes.chartMax = chartMax;
        }
        super.update(changes);
    }
}
